import cookie from '../plugins/jquery.cookie.js';
import Headroom from '../plugins/headroom.js';
import '../plugins/slick.js';

jQuery(function($) {
  // Move the reCAPTCHA disclosure note to sit below the submit button
  function moveRecaptchaNote() {
    $('.gform-recaptcha-note').each(function() {
      var $wrapper = $(this).closest('.gform_wrapper');
      var $footer = $wrapper.find('.gform_footer');
      if ($footer.length) {
        $footer.after(this);
      }
    });
  }
  moveRecaptchaNote();
  $(document).on('gform_post_render', moveRecaptchaNote);

  // Split Carousel
  $('.split-carousel-images').slick({
    arrows: false,
    dots: false,
    autoplay: true,
    // slick waits for the 800ms fade to finish before starting the next timer, so
    // 2200 + 800 = a new slide every 3 seconds.
    autoplaySpeed: 2200,
    fade: true,
    speed: 800,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });


  // Sticky Header
  var myElement = document.querySelector(".global-header");
  var headroom  = new Headroom(myElement, {
    "offset": 150,
    "tolerance": 0
  });
  headroom.init();

  // Footer "Select Language" trigger forwards to the real (header) Google
  // Translate gadget — Google's widget doesn't reliably support two live
  // instances on one page.
  $(document).on('click', '[data-translate-trigger]', function(e){
    e.preventDefault();
    var $headerGadget = $('#google_translate_element_header .goog-te-gadget-simple a');
    if (!$headerGadget.length) {
      return;
    }
    $('html, body').animate({ scrollTop: 0 }, 300, function(){
      $headerGadget[0].click();
    });
  });

  // Google's menu never lists the page's own language, so there is no way back from a
  // translation. Add an "English" entry to the dropdown that clears the translation.
  function addEnglishToTranslateMenu(tries) {
    var frame = document.querySelector('iframe.VIpgJd-ZVi9od-xl07Ob-OEVmcd');
    var doc = null;
    try { doc = frame && frame.contentDocument; } catch (err) { doc = null; }
    var first = doc && doc.querySelector('a.VIpgJd-ZVi9od-vH1Gmf-ibnC6b-gk6SMd');
    if (!first) {
      if (tries < 20) {
        setTimeout(function(){ addEnglishToTranslateMenu(tries + 1); }, 100);
      }
      return;
    }
    if (doc.querySelector('.translate-english')) {
      return;
    }
    var link = doc.createElement('a');
    link.className = 'VIpgJd-ZVi9od-vH1Gmf-ibnC6b translate-english';
    link.href = '#';
    link.innerHTML = '<div style="white-space: nowrap;"><span class="indicator">&rsaquo;</span><span class="text">English</span></div>';
    link.addEventListener('click', function(e){
      e.preventDefault();
      var host = location.hostname;
      ['', '; domain=' + host, '; domain=.' + host].forEach(function(domain){
        document.cookie = 'googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/' + domain;
      });
      location.reload();
    });
    first.parentNode.insertBefore(link, first.nextSibling);
    var menuBody = doc.querySelector('.VIpgJd-ZVi9od-vH1Gmf');
    if (menuBody) {
      menuBody.style.height = 'auto';
      frame.style.height = (menuBody.offsetHeight + 10) + 'px';
    }
  }
  $(document).on('click', '#google_translate_element_header .goog-te-gadget-simple a', function(){
    addEnglishToTranslateMenu(0);
  });

  // Search
  $('.search-toggle').click(function(e){
    e.preventDefault();
    if ($('#search-popup').hasClass('active')) {
      $('#search-popup').removeClass('active');
      return;
    }
    $('#search-popup').addClass('active');
    $('html, body').animate({ scrollTop: 0 }, 300, function(){
      $('#search-input').focus();
    });
  });
  $('.close-search').click(function(){
    $('#search-popup').removeClass('active');
  });
  $(document).on('keydown', function(e){
    if (e.key === 'Escape') {
      $('#search-popup').removeClass('active');
    }
  });

  // Homes archive: filters and pagination load the results via AJAX (the same URL is
  // fetched and only #homes-results is swapped in, so it also works without JS).
  var $homesResults = $('#homes-results');
  if ($homesResults.length) {
    var loadHomes = function(url, push, scroll) {
      $homesResults.addClass('is-loading').attr('aria-busy', 'true');
      $.get(url).done(function(html){
        var $fresh = $('<div>').append($.parseHTML(html)).find('#homes-results');
        if (!$fresh.length) {
          window.location.href = url;
          return;
        }
        $homesResults.html($fresh.html());
        if (push) {
          window.history.pushState({ homes: true }, '', url);
        }
        if (scroll) {
          $('html, body').animate({ scrollTop: $('.homes-filter').offset().top - 150 }, 300);
        }
      }).fail(function(){
        window.location.href = url;
      }).always(function(){
        $homesResults.removeClass('is-loading').removeAttr('aria-busy');
      });
    };

    $('.homes-filter-select').on('change', function(){
      var $form = $(this.form);
      var params = $.param($form.serializeArray().filter(function(f){ return f.value; }));
      loadHomes($form.attr('action') + (params ? '?' + params : ''), true, false);
    });

    $homesResults.on('click', '.pagination a', function(e){
      e.preventDefault();
      loadHomes($(this).attr('href'), true, true);
    });

    window.addEventListener('popstate', function(){
      var query = new URLSearchParams(window.location.search);
      $('.homes-filter-select').each(function(){
        $(this).val(query.get(this.name) || '');
      });
      loadHomes(window.location.href, false, false);
    });
  }

  // Alert Bar
  $('.close-alert-bar').on('click', function(){
    $('.alert-bar').css('display', 'none');
    $.cookie('alert', $('.alert-bar').attr('id'), { path: '/' });
  });

  // Popup Promo
  if ($('.popup-promo').length) {
    var $popupDelay = $('.popup-promo').data('delay') || 0;
    setTimeout(function(){
      $('.popup-promo').addClass('visible');
    }, $popupDelay);
  }
  $('.close-popup-promo').on('click', function(){
    $.cookie('popup', $('.popup-promo').attr('id'), { path: '/' });
    $('.popup-promo').removeClass('visible');
  });

  // Pagination
  $('#pagination').on('click', 'a', function(e){
    if ($(this).closest('#homes-results').length) {
      return; // handled by the Homes archive AJAX loader above
    }
    if (!$('#ajax-posts').length) {
      return; // no AJAX list on this page (e.g. search results): follow the link normally
    }
    e.preventDefault();
    $(this).remove();
    $('#ajax-loader').load($(this).attr('href') + ' #ajax-posts>*', function(){
      $('#ajax-posts').append($('#ajax-loader').html());
    });
    $('#pagination').load($(this).attr('href') + ' #pagination>*');
  });

  // Anchor
  $('a').on('click', function(e){
    var $href = $(this).attr('href');
    if ($href.match('^#') && !$(this).hasClass('accordion-tab')) {
      e.preventDefault();
      $('html, body').stop().animate({
          scrollTop: $($href).offset().top
      });
    }
  });

  // Form Labels
  $('input').on('focus', function(){
    $(this).parent('*').addClass('filled');
  });
  $('input').on('blur', function(){
    if ($(this).val() !== '') {
      $(this).parent('*').addClass('filled');
    } else {
      $(this).parent('*').removeClass('filled');
    }
  });

  // Video popups
  var youtubeIdRegex = /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([\w-]{11})/i;
  $('a').on('click', function(e){
    var $target = $(this).attr('href');
    var $match = $target.match(youtubeIdRegex);
    if ($match) {
      e.preventDefault();
      var $yid = $match[1];
      var $watchUrl = 'https://www.youtube.com/watch?v=' + $yid;

      $('.popup-content').html('<iframe src="https://www.youtube.com/embed/' + $yid + '?autoplay=1" width="1280" height="720" frameborder="0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>');
      $('.popup-video-title').text('');
      $('.popup-video-channel-name').text('').attr('href', '#');
      $('.video-popup-wrapper').addClass('active');
      $('body, html').addClass('body-noscroll');

      $.getJSON('https://www.youtube.com/oembed', { url: $watchUrl, format: 'json' }, function(data){
        $('.popup-video-title').text(data.title);
        $('.popup-video-channel-name').text(data.author_name).attr('href', data.author_url);
        $('.popup-video-share-item-facebook').attr('href', 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent($watchUrl));
        $('.popup-video-share-item-twitter').attr('href', 'https://twitter.com/share?url=' + encodeURIComponent($watchUrl) + '&text=' + encodeURIComponent(data.title));
      });
    }
  });
  $('.close-popup').on('click', function(){
    $('.video-popup-wrapper').removeClass('active');
    $('.popup-content').html('');
    $('.popup-video-title').text('');
    $('.popup-video-channel-name').text('').attr('href', '#');
    $('body, html').removeClass('body-noscroll');
  });

  // Accordion
  $('.accordion-toggle').on('click', function(){
    var $item = $(this).closest('.accordion-item');
    var $content = $item.find('> .accordion-content');
    if ($item.hasClass('active')) {
      $item.removeClass('active');
      $(this).attr('aria-expanded', 'false');
      $content.stop().slideUp(200);
    } else {
      $item.addClass('active');
      $(this).attr('aria-expanded', 'true');
      $content.stop().slideDown(200);
    }
  });

  // Gallery Popup
  $('.gallery-item').on('click', function(){
    var galleryId = $(this).data('gallery');
    var index = $(this).data('index');
    var $popup = $('#gallery-popup-' + galleryId);
    $popup.find('.gallery-popup-slide').removeClass('active');
    $popup.find('.gallery-popup-slide[data-index="' + index + '"]').addClass('active');
    $popup.addClass('active');
    $('body, html').addClass('body-noscroll');
  });
  $('.gallery-popup-close, .gallery-popup-overlay').on('click', function(){
    $(this).closest('.gallery-popup').removeClass('active');
    $('body, html').removeClass('body-noscroll');
  });
  $('.gallery-popup-next').on('click', function(){
    var $slides = $(this).closest('.gallery-popup').find('.gallery-popup-slide');
    var next = $slides.filter('.active').index() + 1;
    if (next >= $slides.length) { next = 0; }
    $slides.removeClass('active').eq(next).addClass('active');
  });
  $('.gallery-popup-prev').on('click', function(){
    var $slides = $(this).closest('.gallery-popup').find('.gallery-popup-slide');
    var prev = $slides.filter('.active').index() - 1;
    if (prev < 0) { prev = $slides.length - 1; }
    $slides.removeClass('active').eq(prev).addClass('active');
  });

  // Mobile Nav
  var $scrollposition = 0;
  $('#mobile-nav-toggle').on('click', function(){
    if ($(this).hasClass('active')) {
      $('body, html').removeClass('nav-locked');
      $(window).scrollTop($scrollposition);
    } else {
      $scrollposition = $(window).scrollTop();
      $('body, html').addClass('nav-locked');
      $(window).scrollTop(0);
    }
    $('#mobile-navigation-wrapper').toggleClass('active');
    $(this).toggleClass('active');
  });

  $('#mobile-navigation > .menu-item-has-children').append('<button type="button" class="submenu-toggle" aria-label="Toggle submenu" aria-expanded="false"></button>');
  $('#mobile-navigation').on('click', '.submenu-toggle', function(){
    var $item = $(this).parent();
    $item.siblings('.open').removeClass('open').children('.submenu-toggle').attr('aria-expanded', 'false');
    $item.toggleClass('open');
    $(this).attr('aria-expanded', $item.hasClass('open') ? 'true' : 'false');
  });

  var scroll_actions = function() {
    $('.loading').each(function(){
      $(this).addClass('loaded');
    });
    for (var i = 0; i <= 21; i++) {
      var selector = i === 0 ? '.animate' : '.animate-' + i;
      var delay = i * 100;
      $(selector).each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){ $this.addClass('visible'); }, delay);
        }
      });
    }
  };

  $(window).on('load', function(){
    $(window).trigger('resize');
    setTimeout(function(){ $(window).trigger('resize'); }, 500);
    scroll_actions();
  });
  $(document).ready(scroll_actions);
  $(window).on('scroll', scroll_actions);

});